export const forbidWhenNoPermission = (
  hasPermission: boolean | undefined
): React.MouseEventHandler<HTMLAnchorElement> => {
  return hasPermission
    ? (): void => {}
    : (): void => {
        window.location.href = `${window.location.protocol}//${window.location.host}/forbidden`;
      };
};
